import { api } from "@/lib/api";

export function pushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export function pushPermission() {
  return pushSupported() ? Notification.permission : "unsupported";
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) arr[i] = raw.charCodeAt(i);
  return arr;
}

export async function getExistingSubscription() {
  if (!pushSupported()) return null;
  try {
    const reg = await navigator.serviceWorker.ready;
    return reg.pushManager.getSubscription();
  } catch (e) {
    return null;
  }
}

export async function subscribeToPush() {
  if (!pushSupported()) return { ok: false, reason: "unsupported" };
  let key = "";
  try {
    const { data } = await api.get("/push/vapid-public-key");
    if (!data.configured || !data.key) return { ok: false, reason: "not_configured" };
    key = data.key;
  } catch (e) {
    return { ok: false, reason: "not_configured" };
  }

  const perm = await Notification.requestPermission();
  if (perm !== "granted") return { ok: false, reason: perm };

  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(key),
    });
  }
  await api.post("/push/subscribe", { subscription: sub.toJSON() });
  return { ok: true };
}

export async function unsubscribeFromPush() {
  const sub = await getExistingSubscription();
  if (sub) {
    try {
      await api.post("/push/unsubscribe", { endpoint: sub.endpoint });
    } catch (e) {
      /* best-effort */
    }
    try {
      await sub.unsubscribe();
    } catch (e) {
      /* best-effort */
    }
  }
  return { ok: true };
}
